/**
 * Single source of truth for the app chrome dimensions.
 *
 * These used to be repeated as magic strings ("4.7rem" in NavBar, "5rem" in
 * HandleProfile's drawers, "25%" / "20%" for the sidebar gutter) and they did
 * not agree with each other, which is what produced overlapping / unclickable
 * regions at some viewport widths. Import from here instead of hard-coding.
 */

/** Height of the fixed top navigation bar. */
export const NAVBAR_HEIGHT = '4.7rem';

/**
 * Top offset a page should leave for the navbar. Slightly larger than
 * NAVBAR_HEIGHT so content never sits flush against the bar.
 */
export const CONTENT_TOP_OFFSET = '5rem';

/** Width of the permanent (md and up) sidebar drawer, in px. */
export const SIDEBAR_WIDTH = 260;

/** Width of the temporary (below md) sidebar drawer. */
export const MOBILE_SIDEBAR_WIDTH = { xs: '85%', sm: 320 };

/**
 * The navbar must paint above the drawers (MUI drawer = 1200) so the logo is
 * never clipped by the sidebar, but below modals/dialogs (1300).
 */
export const NAVBAR_Z_INDEX = 1250;
